<template>
  <div :class="$style.box">
    <Popup v-model="show" position="top" :style="{ height: '100%' }" close-on-popstate>
      <!-- 搜索栏 -->
      <div :class="$style.top">
        <!-- 搜索框 -->
        <div :class="$style.bar">
          <div :class="$style.menu" @click.stop="menuClick">
            {{ menuText }}
            <Icon name="arrow-down" />
            <!-- 下拉菜单 -->
            <div :class="$style.menuItem" v-if="menuShow">
              <p v-for="(item, index) in option" :key="index" @mousedown="chooseMenu(item)">
                {{ item.text }}
              </p>
            </div>
          </div>
          <input type="text" v-model="keyword" />
        </div>
        <!-- 按钮 -->
        <div :class="[$style.button, $style.searchBtn]" @click="handleSearch(true)">搜索</div>
        <div :class="[$style.button, $style.cancelBtn]" @click="handleCancel">取消</div>
      </div>
      <div :class="$style.placeholder"></div>
      <!-- 帖子列表 -->
      <div ref="view" :class="$style.view" @scroll="listenScroll">
        <div :class="$style.loading" v-if="loading">
          <Loading type="circular" color="#1989fa" vertical></Loading>
        </div>
        <div ref="scroll" :class="$style.scroll" v-else>
          <!-- 无数据展示 -->
          <div :class="$style.empty" v-if="empty">
            <p>未搜索到任何数据哦~</p>
            <img :src="emptyImage" />
          </div>
          <!-- 有数据时展示列表 -->
          <div id="list" v-else>
            <TopicListItem
              v-for="item of searchData"
              :key="item.id"
              :topicItem="item"
              :isNew="false"
              @click.native="linkToDetail(item.id)"
            />
            <div :class="$style.listLoading" v-if="listLoading">
              <Loading type="circular" color="#1989fa" vertical></Loading>
            </div>
            <div :class="$style.listLoading" v-if="endSearch">—— 我是有底线的 ——</div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import TopicListItem from './TopicListItem';
import { Popup, Search, Icon, Loading } from 'vant';
import { CDN_URL } from '@/config/index.js';
import { search } from '@/api/gameCircle';
import { highlight } from '@/utils/index.js';

export default {
  name: 'search',
  components: { Popup, Search, Icon, Loading, TopicListItem },
  props: {
    circleId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      emptyImage: `${CDN_URL}/empty.png`, // 无回复滑稽黑猫图片
      option: [
        { text: '按内容', value: 1 },
        { text: '按用户', value: 2 },
      ],
      params: {
        game_circle_id: '',
        search_type: 0,
        keyword: '',
        page: 1,
        limit: 10,
      },
      keyword: '', // 搜索关键字
      value: 1, // 菜单当前选中 value
      show: false, // 搜索弹窗显示
      menuShow: false, // 菜单是否显示
      empty: true, // 搜索内容是否为空
      loading: false, // 是否显示加载
      listLoading: false, // 分页加载是否显示
      searchData: [], // 搜索回来的数据
      endSearch: false, // 是否是当前搜索项分页最后一次搜索
    };
  },
  computed: {
    menuText() {
      const filterItem = this.option.filter((m) => m.value === this.value);
      return filterItem[0]['text'];
    },
  },
  methods: {
    // 监听滚动到底部
    listenScroll() {
      //scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = this.$refs.view.scrollTop;
      //windowHeight是可视区的高度
      var windowHeight = this.$refs.view.clientHeight;
      //scrollHeight是滚动条的总高度
      var scrollHeight = this.$refs.scroll.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight  > scrollHeight - 20) {
        if (this.listLoading === true || this.endSearch === true) return;
        console.log('到了底部, 加载数据');
        this.params.page++;
        this.handleSearch();
      }
    },
    // 跳转到帖子详情页
    linkToDetail(id) {
      this.$router.push({ name: 'gameCircle.details', query: { circleId: this.circleId, id } });
    },
    // 显示搜索弹窗
    showSearch() {
      this.show = true;
    },
    // 点击取消
    handleCancel() {
      this.show = false;
      this.$emit('cancelSearch');
    },
    // 点击菜单项
    chooseMenu(item) {
      this.value = item.value;
      this.menuShow = false;
    },
    // 点击选择菜单
    menuClick() {
      this.menuShow = true;
    },
    // 点击搜索
    async handleSearch(flag) {
      if (flag) {
        // 点击搜索按钮才会改变搜索条件
        this.params.game_circle_id = this.circleId;
        this.params.search_type = this.value;
        this.params.keyword = this.keyword;
        this.params.page = 1;
        this.loading = true;
      } else {
        this.listLoading = true;
      }
      const { code, data } = await search(this.params);
      if (code !== 1) {
        this.loading = false;
        this.listLoading = false;
        this.empty = true;
        return;
      }
      this.loading = false;
      this.listLoading = false;
      // 搜索数据为空
      if (data.length === 0 && flag) {
        // 无数据且是第一次搜索 - 展示无数据
        this.empty = true;
        return;
      } else if (data.length === 0 && !flag) {
        // 无数据但不是第一次搜索 - 为分页搜索
        this.endSearch = true;
      }
      this.empty = false;
      // 处理数据
      if (flag) {
        this.searchData = [];
      }
      data.forEach((m) => {
        m.content = m.content_split;
        this.searchData.push(m);
        this.$nextTick(() => {
          // 按用户查询设置高亮
          if (this.value === 2) {
            m.highlight.forum_name && this.highlightAdd(m.highlight.forum_name, '.forum_name');
          } else {
            // 按内容查询设置高亮 - title 循环
            m.highlight.title && this.highlightAdd(m.highlight.title, '.title');
            // 按内容查询设置高亮 - content 循环
            m.highlight.content_split &&
              this.highlightAdd(m.highlight.content_split, '.content_split');
          }
        });
      });
    },
    // 循环遍历添加高亮样式
    highlightAdd(keywords, className) {
      keywords.forEach((n) => {
        const reg = new RegExp(n.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
        const list = document.getElementById('list');
        const name = list.querySelectorAll(className);
        name.forEach((i) => {
          highlight(i, reg);
        });
      });
    },
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
}
.top {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0px 10px;
  box-shadow: 0px 1px 8px 1px #ccc;
  position: fixed;
  top: 0;
  z-index: 10;
  background-color: #fff;
  .bar {
    width: 230px;
    height: 36px;
    display: flex;
    border-radius: 5px;
    // border: 0.5px solid #ddd;
    box-shadow: 0 -1px 2px -1px #a1a1a1,
      //上边线
      1px 0 2px -1px #a1a1a1,
      //右边线
      0 1px 2px -1px #a1a1a1,
      //下边线
      -1px 0 2px -1px #a1a1a1; //左边线

    box-sizing: content-box;
    .menu {
      width: 70px;
      height: 36px;
      background-color: #fff;
      // background-color: pink;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      font-size: 12px;
      text-align: center;
      line-height: 36px;
      .menuItem {
        width: 100%;
        min-height: 36px;
        background-color: #fff;
        box-shadow: 0px 0px 10px #ccc;
      }
    }
    > input {
      width: 160px;
      height: 100%;
      background-color: rgb(230, 230, 230);
      // background-color: blue;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      padding-left: 10px;
    }
  }
  .button {
    width: 50px;
    height: 30px;
    font-size: 12px;
    text-align: center;
    line-height: 30px;
    margin-left: 8px;
    border-radius: 14px;
  }
  .searchBtn {
    background-color: rgb(64, 125, 231);
    color: #fff;
  }
  .cancelBtn {
    border: 1px solid rgb(247, 1, 1);
    color: rgb(247, 1, 1);
  }
}
.placeholder {
  width: 100%;
  height: 50px;
}
.view {
  width: 100%;
  height: calc(100% - 50px);
  overflow-y: scroll;
  .scroll {
    width: 100%;
    height: 100%;
    background-color: #fff;
    .empty {
      width: 100%;
      height: 100%;
      padding-top: 140px;
      > p {
        width: 100%;
        text-align: center;
        color: rgba(159, 159, 159, 1);
        line-height: 30px;
        font-size: 12px;
      }
      > img {
        width: 84%;
        display: block;
        margin: 50px auto 0px auto;
      }
    }
    .listLoading {
      width: 100%;
      height: 20px;
      text-align: center;
      color: rgba(159, 159, 159, 1);
      line-height: 20px;
      font-size: 12px;
    }
  }
}
</style>
<style>
.highlight {
  color: red;
  font-weight: bold;
}
</style>